function validarCPF(value) {
	function calculateCPFCheckDigit(
		/** @type {string} */ cpf,
		/** @type {number} */ length
	) {
		const cpfSlice = cpf.slice(0, length);
		const weights = Array.from({length}, (_, i) => length + 1 - i);
		const sum = cpfSlice
			.split('')
			.reduce((acc, digit, index) => acc + parseInt(digit) * weights[index], 0);
		const remainder = sum % 11;

		return remainder < 2 ? 0 : 11 - remainder;
	}

	// Remove caracteres não numéricos do CPF
	const cleanedCPF = value.replace(/\D/g, '');

	// Verifica se o CPF possui 11 dígitos
	if (cleanedCPF.length !== 11) {
		return {isValid: false, message: 'O CPF não possui 11 digitos'};
	}

	// Verifica se todos os dígitos são iguais; nesse caso, o CPF é inválido
	if (/^(\d)\1{10}$/.test(cleanedCPF)) {
		return {isValid: false, message: 'CPF inválido.'};
	}

	// Calcula os dígitos verificadores
	const digit1 = calculateCPFCheckDigit(cleanedCPF, 9);
	const digit2 = calculateCPFCheckDigit(cleanedCPF, 10);

	// Verifica se os dígitos verificadores calculados são iguais aos fornecidos no CPF
	if (
		digit1.toString() === cleanedCPF.charAt(9) &&
		digit2.toString() === cleanedCPF.charAt(10)
	) {
		return {isValid: true};
	}

	return {isValid: false, message: 'CPF inválido.'};
}

function formatarCPF(value) {
	const cleanedCpf = value.replace(/\D/g, '');

	// return (cleanedCpf);
	// Verifica se o CPF possui 11 dígitos
	if (cleanedCpf.length <= 11) {
		// Formata o CPF
		const formattedCpf = cleanedCpf.replace(
			/(\d{3})(\d{3})(\d{3})(\d{2})/,
			'$1.$2.$3-$4'
		);
		// Atualiza o estado com o CPF formatado
		return formattedCpf;
	} else {
		// Se o CPF não tiver 11 dígitos, atualiza o estado com o valor atual
		return cleanedCpf;
	}
}
